import React, { useEffect, useState } from "react";
import Common from "../based/Common";
import { NOTIFY } from "../based/Constants";
import CommonModal from "../based/Modal";
import { Notify } from "../based/Notify";
import Request from "../based/Request";
import Textbox from "../based/inputs/Textbox";
import GiftServices from "../based/services/GiftServices";
import useFormValidate from "../hooks/useFormValidate";

const GiftTypeModel = {
    id: 0,
    icon: "",
    name: "",
};

const AddOrEditModalGiftType = ({ id, onSaveContinue, onClose, isShowModal }) => {
    const [isBusy, setIsBusy] = useState(false);
    const [model, setModel] = useState(GiftTypeModel);
    const { addRef, displayError, isValid } = useFormValidate();

    useEffect(() => {
        if (id > 0) _getTag(id);
        return () => setModel({});
    }, [id]);

    const _getTag = async (id) => {
        setIsBusy(true);
        let [err, data] = await GiftServices.GetGiftTypeById(id);
        if (!err && data) setModel({ ...data });
        else setModel(GiftTypeModel);
        setIsBusy(false);
    };

    const _handleSave = async () => {
        setIsBusy(true);
        let [err, data] = await GiftServices.CreateUpdateGiftType(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            onSaveContinue();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
        setIsBusy(false);
    };
    return (
        <CommonModal show={isShowModal} id={Common.generateGuid()} isBusy={isBusy} busyMsg={"Đang tải dữ liệu"} title={id > 0 ? "Cập nhật" : "Thêm mới"} onSave={_handleSave} onClose={() => onClose()}>
            <div className="form-group">
                <label htmlFor="name" className="required">
                    Tên hiển thị:
                </label>
                <Textbox id="name" name="name" required ref={addRef} className="form-control" onChanged={(name, value) => setModel({ ...model, name: value })} value={model.name} />
            </div>
            <div className="form-group">
                <label htmlFor="">Icon</label>
                <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                        let file = e.target.files[0];
                        if (file) {
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                Request.UploadImage(file).then((res) => {
                                    if (res && res.data) {
                                        let { imageUrl, thumbnailUrl } = res.data;
                                        setModel({ ...model, icon: imageUrl });
                                    }
                                });
                            };
                            reader.readAsDataURL(file);
                        }
                    }}
                />
                {model.icon && <img src={model.icon} alt="icon" style={{ width: "100px", height: "100px" }} />}
            </div>
        </CommonModal>
    );
};

export default AddOrEditModalGiftType;
